import VueCharts from 'vue-chartjs'
export default {
    extends: VueCharts.Bar,
    data: () => ({
        labels: [],
        evidencia: [],
        sinEvidencia: [],
        envidenciaIncompatible: [],
        total: []
    }),
    mounted() {
        var self = this
        self.$ajax.get('/ENROLLMENT_TRANSACTION/GetTransactionsProgressAsync').then(response => {

            for (var i = 0; i < response.data.length; i++) {
                self.labels.push(response.data[i].REGION_NAME)
                self.evidencia.push(response.data[i].EVIDENCE)
                self.sinEvidencia.push(response.data[i].NO_EVIDENCE)
                self.envidenciaIncompatible.push(response.data[i].INCOMPATIBLE_EVIDENCE)
                self.total.push(response.data[i].TOTAL)
            }

            self.renderChart({
                labels: self.labels,
                datasets: [
                    {
                        label: 'Con Evidencia/s',
                        backgroundColor: '#e6b400',
                        data: self.evidencia
                    },
                    {
                        label: 'Sin Evidencia/s',
                        backgroundColor: '#dce775',
                        data: self.sinEvidencia
                    },
                    {
                        label: 'Evidencia Incompatible',
                        backgroundColor: '#e65a3b',
                        data: self.envidenciaIncompatible
                    },
                    {
                        label: 'Total',
                        backgroundColor: '#ba68c8',
                        data: self.total
                    }
                ]
            }, {
                    responsive: true,
                    responsiveAnimationDuration: 1000,
                    maintainAspectRatio: false
                })
        }).catch(response => {
            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/monitoria/reportes/progresoTransacciones.js